export default "__VITE_ASSET__cadf9a26__"